import { z } from 'zod';

import { getGeneralStaticBuilderSchema } from '~/utils/validation/qrCodeBuilder';

export const getSchema = ({ t }) => {
  return z
    .object({
      text: z
        .string({ message: t('inputs:required') })
        .trim()
        .min(1, t('inputs:required'))
        .max(300, t('errors:max', { count: 300 })),
    })
    .merge(getGeneralStaticBuilderSchema());
};
